//
// This file is auto generated. See ./README.md for details
//
import React from 'react'
import { Icon as ChakraIcon } from '@chakra-ui/react'
import {
  HubResponsiveValue,
  StandardIconSizes,
  HubStyleObject,
  forwardRef,
} from '@hub/design-system-base'
import { WestfieldDirectServiceLargeSVG } from './svg'

interface WestfieldDirectServiceLargeIconProps {
  boxSize?: HubResponsiveValue<StandardIconSizes>
  sx?: HubStyleObject
}

export const WestfieldDirectServiceLargeIcon: React.FC<WestfieldDirectServiceLargeIconProps> = forwardRef<
  WestfieldDirectServiceLargeIconProps,
  typeof ChakraIcon
>(({ boxSize = 'size-icon-sm', sx }, ref) => (
  <ChakraIcon
    ref={ref}
    boxSize={boxSize}
    as={WestfieldDirectServiceLargeSVG}
    sx={sx}
  />
))
